export default __webpack_public_path__ + "static/opusBrandMark-93c3ba9462b102e519c660936ea24015.png";